import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* NAVBAR */}
      <Navbar />

      {/* MAIN */}
      <main className="flex-1">
        <section className="container mx-auto max-w-5xl px-4 py-12">

          {/* CARD */}
          <div className="rounded-2xl border border-border bg-card p-6 md:p-10 shadow-sm">

            {/* HEADER */}
            <div className="mb-10">
              <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground">
                About Deal<span className="text-primary">Swapify</span>
              </h1>

              <p className="mt-4 text-muted-foreground max-w-3xl">
                DealSwapify is a modern marketplace platform that helps people
                buy, sell, donate, and exchange items within their communities
                easily and securely.
              </p>
            </div>

            {/* MISSION */}
            <div className="mb-10">
              <h2 className="text-2xl font-semibold mb-3">
                Our Mission
              </h2>

              <p className="text-muted-foreground leading-7">
                Our mission is to reduce waste and encourage smarter reuse of
                products by connecting people who have useful items with those
                who need them. We believe many items still have value and should
                not go unused.
              </p>
            </div>

            {/* FEATURES */}
            <div className="mb-10">
              <h2 className="text-2xl font-semibold mb-5">
                What You Can Do
              </h2>

              <div className="grid gap-4 sm:grid-cols-2">

                <div className="rounded-xl border border-border bg-secondary p-5">
                  <h3 className="font-semibold text-lg">
                    Buy and Sell
                  </h3>

                  <p className="mt-2 text-sm text-muted-foreground">
                    Post items for sale and connect directly with interested
                    buyers in real time.
                  </p>
                </div>

                <div className="rounded-xl border border-border bg-secondary p-5">
                  <h3 className="font-semibold text-lg">
                    Donate and Give Away
                  </h3>

                  <p className="mt-2 text-sm text-muted-foreground">
                    Help others by donating items or giving them away for free.
                  </p>
                </div>

                <div className="rounded-xl border border-border bg-secondary p-5">
                  <h3 className="font-semibold text-lg">
                    Real-Time Messaging
                  </h3>

                  <p className="mt-2 text-sm text-muted-foreground">
                    Communicate instantly with buyers and sellers using the
                    built-in marketplace chat.
                  </p>
                </div>

                <div className="rounded-xl border border-border bg-secondary p-5">
                  <h3 className="font-semibold text-lg">
                    Smart Notifications
                  </h3>

                  <p className="mt-2 text-sm text-muted-foreground">
                    Receive notifications for messages, listings, and important
                    marketplace updates.
                  </p>
                </div>

              </div>
            </div>

            {/* SAFETY */}
            <div className="mb-10">
              <h2 className="text-2xl font-semibold mb-3">
                User Safety
              </h2>

              <p className="text-muted-foreground leading-7">
                We encourage users to meet in safe public places, verify item
                details before transactions, and report suspicious activity.
                DealSwapify continuously works to improve platform safety and
                user experience.
              </p>
            </div>

            {/* PRIVACY */}
            <div className="mb-10 rounded-2xl border border-border bg-secondary p-6">

              <h2 className="text-2xl font-semibold mb-3">
                Privacy Policy
              </h2>

              <p className="text-muted-foreground mb-4">
                Your privacy matters to us. Learn how we collect, use, and
                protect your information while using DealSwapify.
              </p>

              <Link
                to="/privacy-policy"
                className="inline-flex items-center rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white hover:opacity-90 transition"
              >
                View Privacy Policy
              </Link>

            </div>

            {/* CONTACT */}
            <div>
              <h2 className="text-2xl font-semibold mb-3">
                Contact Us
              </h2>

              <p className="text-muted-foreground leading-7">
                If you have questions, suggestions, or support requests, feel
                free to reach out through our platform support channels.
              </p>
            </div>

          </div>

        </section>
      </main>

      {/* FOOTER */}
      <Footer />
    </div>
  );
};

export default AboutPage;